<nz-modal
  [nzVisible]="visible()"
  [nzWidth]="720"
  [nzFooter]="null"
  [nzClosable]="false"
  [nzBodyStyle]="{ 'max-height': '80vh', 'overflow-y': 'auto' }"
  nzCentered
  (nzOnCancel)="cancel()"
>
  <ng-container *nzModalContent>
    <div class="flex flex-col px-2 py-4">
      <div class="flex items-start justify-between gap-4 mb-8">
        <h1 class="text-base font-bold uppercase text-main-color">{{ title() }}</h1>
        <button
          type="button"
          class="text-gray-400 hover:text-gray-600 transition-colors"
          aria-label="Close"
          (click)="cancel()"
        >
          <span nz-icon nzType="close"></span>
        </button>
      </div>

      @if (isLoading()) {
        <div class="flex flex-col justify-center items-center py-20">
          <nz-spin nzSimple nzSize="large"></nz-spin>
          <p class="mt-6 text-gray-500 text-lg">Processing, please wait...</p>
        </div>
      } @else if (!activeFee()) {
        <div class="flex flex-col items-center gap-4 py-16">
          <p class="text-gray-500 text-center">
            No active payment option is available right now. Please try again later.
          </p>
          <button nz-button nzSize="large" (click)="cancel()">Close</button>
        </div>
      } @else {
        <div class="flex flex-col gap-6">
          <!-- Amount / fee summary -->
          <lib-payment-summary
            [isManualInput]="isManualInput()"
            [cart]="summaryData()"
            [showCouponCode]="false"
            (priceChange)="onPriceChange($event)"
          ></lib-payment-summary>

          <!-- Currency switcher -->
          @if (availableCurrencies().length > 1) {
            <div
              class="flex bg-white items-center justify-between gap-4 rounded-md border border-gray-300 px-6 py-3"
            >
              <div class="flex flex-col gap-1">
                <p class="text-sm font-medium">Change currency?</p>
                <span class="text-xs opacity-75">In case you want to change the currency</span>
              </div>
              <nz-select
                class="!w-32"
                [ngModel]="selectedCurrencyId()"
                (ngModelChange)="selectCurrency($event)"
                [nzPlaceHolder]="currencyLabel()"
              >
                @for (item of availableCurrencies(); track item.currencyId) {
                  <nz-option
                    [nzValue]="item.currencyId"
                    [nzLabel]="currencyCode(item.currency)"
                  ></nz-option>
                }
              </nz-select>
            </div>
          }

          <!-- Payment methods -->
          <div class="flex flex-col gap-4 w-full">
            <!-- Zimswitch -->
            <div class="flex flex-col bg-white transition-all">
              <div
                class="flex items-center justify-between rounded border border-gray-300 py-3 px-6 cursor-pointer transition-colors"
                [ngClass]="{ 'bg-[#f3e9eb]': selectedPaymentSection() === 'ZIMSWITCH' }"
                role="button"
                tabindex="0"
                (click)="togglePaymentOption('ZIMSWITCH')"
                (keyup.enter)="togglePaymentOption('ZIMSWITCH')"
              >
                <div class="flex gap-2 items-center">
                  <img src="/images/card-front.webp" class="w-6" alt="Zimswitch" />
                  <p class="text-sm">Zimswitch</p>
                </div>
                <span
                  nz-icon
                  nzType="down"
                  class="text-gray-500 transition-all"
                  [class.rotate-180]="selectedPaymentSection() === 'ZIMSWITCH'"
                ></span>
              </div>
              @if (selectedPaymentSection() === 'ZIMSWITCH' && paymentConfig()) {
                <lib-zimswitch [payloadConfig]="paymentConfig()!"></lib-zimswitch>
              }
            </div>

            <!-- Visa & Mastercard -->
            <div class="flex flex-col bg-white transition-all">
              <div
                class="flex items-center justify-between rounded border border-gray-300 py-3 px-6 cursor-pointer transition-colors"
                [ngClass]="{ 'bg-[#f3e9eb]': selectedPaymentSection() === 'MASTERCARD' }"
                role="button"
                tabindex="0"
                (click)="togglePaymentOption('MASTERCARD')"
                (keyup.enter)="togglePaymentOption('MASTERCARD')"
              >
                <div class="flex gap-2 items-center">
                  <img src="/images/logos_visa.png" class="w-6" alt="Visa" />
                  <img src="/images/logos_mastercard.png" class="w-6" alt="Mastercard" />
                  <p class="text-sm">Visa &amp; Mastercard</p>
                </div>
                <span
                  nz-icon
                  nzType="down"
                  class="text-gray-500 transition-all"
                  [class.rotate-180]="selectedPaymentSection() === 'MASTERCARD'"
                ></span>
              </div>
              @if (selectedPaymentSection() === 'MASTERCARD' && paymentConfig()) {
                <lib-mastercard
                  [payloadConfig]="paymentConfig()!"
                  [compact]="true"
                  (paymentSubmitted)="onPaymentSubmitted($event)"
                ></lib-mastercard>
              }
            </div>

            <!-- EcoCash -->
            <div class="flex flex-col bg-white transition-all">
              <div
                class="flex items-center justify-between rounded border border-gray-300 py-3 px-6 cursor-pointer transition-colors"
                [ngClass]="{ 'bg-[#f3e9eb]': selectedPaymentSection() === 'ECOCASH' }"
                role="button"
                tabindex="0"
                (click)="togglePaymentOption('ECOCASH')"
                (keyup.enter)="togglePaymentOption('ECOCASH')"
              >
                <div class="flex gap-2 items-center">
                  <img src="/images/ecocash-logo.png" class="w-10" alt="EcoCash" />
                  <p class="text-sm">EcoCash</p>
                </div>
                <span
                  nz-icon
                  nzType="down"
                  class="text-gray-500 transition-all"
                  [class.rotate-180]="selectedPaymentSection() === 'ECOCASH'"
                ></span>
              </div>
              @if (selectedPaymentSection() === 'ECOCASH' && paymentConfig()) {
                <lib-ecocash
                  [payloadConfig]="paymentConfig()!"
                  [compact]="true"
                  (paymentSubmitted)="onPaymentSubmitted($event)"
                ></lib-ecocash>
              }
            </div>
          </div>
        </div>
      }
    </div>
  </ng-container>
</nz-modal>


